module.exports = __webpack_public_path__ + "static/media/students-icon-1.ed7257e9.svg";